import React from 'react';
import './App.css';
import AppRoutes from './Routes';
import Navbar from './Components/Navbar';
import Footer from './Components/Footer';


function App() {
  return (
    <>
      <Navbar />
     
      <AppRoutes />
      <Footer />
    </>
  );
}

export default App;